import { Injectable } from '@angular/core';



const STORAGE_PREFIX = 'logiciel_caisse_module_enabled_';



@Injectable({ providedIn: 'root' })

export class LogicielCaisseModuleService {

  private resolveErpUserId(): number | null {

    try {

      const raw = localStorage.getItem('currentUser');

      if (!raw) {

        return null;

      }

      const id = Number(JSON.parse(raw)?.id);

      return Number.isFinite(id) && id > 0 ? id : null;

    } catch {

      return null;

    }

  }



  private storageKey(code_station: string, erpUserId?: number | null): string | null {

    const code = String(code_station || '').trim();

    const uid = erpUserId ?? this.resolveErpUserId();

    if (!code || !uid) {

      return null;

    }

    return `${STORAGE_PREFIX}${uid}_${code}`;

  }



  isEnabled(code_station: string): boolean {

    const key = this.storageKey(code_station);

    return key != null && localStorage.getItem(key) === '1';

  }



  enable(code_station: string): void {

    const key = this.storageKey(code_station);

    if (key) {

      localStorage.setItem(key, '1');

    }

  }



  /** Active le module pour les codes ERP et caisse (ex. 014 vs 001). */
  enableCodes(...codes: Array<string | null | undefined>): void {
    for (const code of codes) {
      const normalized = String(code || '').trim();
      if (normalized) {
        this.enable(normalized);
      }
    }
  }

  disable(code_station: string): void {

    const key = this.storageKey(code_station);

    if (key) {

      localStorage.removeItem(key);

    }

  }

}


